import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Truck, Sparkles, Home as HomeIcon, ShieldCheck } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import useSEO from "../hooks/useSEO";
import { Button } from "../components/ui/button";

const HowItWorks = () => {
  const { tr, lang, lp } = useLang();
  useSEO({ title: `${tr.steps.title} — MobiRider`, description: tr.hero.subtitle, lang });
  const steps = [
    { icon: CheckCircle2, t: tr.steps.s1t, d: tr.steps.s1d },
    { icon: Truck, t: tr.steps.s2t, d: tr.steps.s2d },
    { icon: Sparkles, t: tr.steps.s3t, d: tr.steps.s3d },
    { icon: HomeIcon, t: tr.steps.s4t, d: tr.steps.s4d },
  ];
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 md:py-20">
      <h1 className="font-heading font-extrabold text-4xl md:text-5xl text-ink tracking-tight text-center">{tr.steps.title}</h1>
      <div className="mt-14 space-y-6">
        {steps.map((s, i) => (
          <div key={i} className="flex items-start gap-6 bg-white rounded-3xl p-7 border border-slate-100 shadow-md">
            <div className="w-16 h-16 rounded-2xl bg-brand text-white grid place-items-center shrink-0"><s.icon className="w-8 h-8" /></div>
            <div>
              <div className="text-accent2 font-heading font-bold text-lg">{tr.flow.step} {i + 1}</div>
              <h3 className="font-heading font-bold text-2xl text-ink">{s.t}</h3>
              <p className="text-lg text-ink-muted mt-2 leading-relaxed">{s.d}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-10 bg-cream rounded-3xl p-8 flex items-center gap-4">
        <ShieldCheck className="w-10 h-10 text-brand shrink-0" />
        <p className="text-lg text-ink">{tr.hero.trust1} · {tr.hero.trust2} · {tr.hero.trust3}</p>
      </div>
      <div className="text-center mt-10">
        <Link to={lp("/reservation")}><Button className="rounded-full h-16 px-10 bg-accent2 hover:bg-accent2-hover text-white font-bold text-xl">{tr.cta.bookNow}</Button></Link>
      </div>
    </div>
  );
};

export default HowItWorks;
